// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"_2rxIrGG7TB5S7n7wxrZBfp","open":"cL70DZAX7G2VawHjCbmuv","window":"_3KcASfZHRuIJh-Pztn1D8n","content":"U7wQV30ASJ4qHFXcxt7UF","buttons":"Y_fXABqg-jBDWmwwZmKiz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DialogModal/style.css
// module id = 290
// module chunks = 0